import { App, Plugin } from "vue";
import { odsBox } from "omind-design-system/components/odsBox";
import { odsButton } from "omind-design-system/components/odsButton";
import { odsCard } from "omind-design-system/components/odsCard";
import { odsCheckbox } from "omind-design-system/components/odsCheckbox";
import { odsFieldMessage } from "omind-design-system/components/odsFieldMessage";
import { odsIcon } from "omind-design-system/components/odsIcon";
import { odsInput } from "omind-design-system/components/odsInput";
import { odsLogo } from "omind-design-system/components/odsLogo";
import { odsNavigation } from "omind-design-system/components/odsNavigation";
import { odsPill } from "omind-design-system/components/odsPill";
import { odsPopup } from "omind-design-system/components/odsPopup";
import { odsSelect } from "omind-design-system/components/odsSelect";
import { odsTextarea } from "omind-design-system/components/odsTextarea";
import { odsRadar } from "omind-design-system/components/odsRadar";
import { odsSwitch } from "omind-design-system/components/odsSwitch";
import { odsDropdown } from "omind-design-system/components/odsDropdown";

export {
  BorderRadius,
  Spacing,
  Shadow,
  FlexDirection,
  //FlexDirectionLiteral,
  Size,
  Align,
  Justify,
  AsidePosition,
} from "omind-design-system/tokens";
export {
  ButtonColor,
  ButtonType,
  ButtonSize,
} from "omind-design-system/components/odsButton";
export {
  LogoColor,
} from "omind-design-system/components/odsLogo";
export {
  IconSize,
} from "omind-design-system/components/odsIcon";
export {
  popupManager,
} from "omind-design-system/components/odsPopup";


const ODS: Plugin = {
  install(Vue: App) {
    Vue.component('odsBox', odsBox);
    Vue.component('odsButton', odsButton);
    Vue.component('odsCard', odsCard);
    Vue.component('odsCheckbox', odsCheckbox);
    Vue.component('odsFieldMessage', odsFieldMessage);
    Vue.component('odsIcon', odsIcon);
    Vue.component('odsInput', odsInput);
    Vue.component('odsLogo', odsLogo);
    Vue.component('odsNavigation', odsNavigation);
    Vue.component('odsPill', odsPill);
    Vue.component('odsPopup', odsPopup);
    Vue.component('odsSelect', odsSelect);
    Vue.component('odsTextarea', odsTextarea);
    Vue.component('odsRadar', odsRadar);
    Vue.component('odsSwitch', odsSwitch);
    Vue.component('odsDropdown', odsDropdown);
  },
};

export default ODS;